import React from "react";

/* A picture — an empty logo or banner slot. */
export const ImageIcon = ({ size = 16, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
       aria-hidden="true" focusable="false" className={className}>
    <rect x="3" y="4.5" width="18" height="15" rx="2.2"
          stroke="currentColor" strokeWidth="1.7" />
    <circle cx="8.6" cy="9.8" r="1.7" stroke="currentColor" strokeWidth="1.7" />
    <path d="M3.4 17.2l4.7-4.2a2 2 0 012.7.05l3.5 3.3 2.2-1.9a2 2 0 012.7.06l1.4 1.3"
          stroke="currentColor" strokeWidth="1.7"
          strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default ImageIcon;
